<template>
  <div class="contain">
    <!-- 头部-->
    <head-comp></head-comp>  
    <!-- banner图 -->
    <div class="banner-box">
      <div class="banner"  @click="jumpToClu" v-html="bgTwo">
        <!-- <img :src="bgTwo"> -->
      </div>
    </div>
    <!-- 内容-->
    <div class="w100">
      <div class="w12 bgc-f paddingtop">
        <!-- 左边/右边-->
        <div class="column-left l">
          <!-- 招生计划 招生章程-->
          <div class="panel panel-primary note " v-for="(item,index) in enrollStu" :key="index">
            <div class="panel-heading">
              <h3 class="panel-title">
                <span class="glyphicon glyphicon-bullhorn" aria-hidden="true" ></span>
                {{item.name}}
                <a class="more" href="javascript:;" @click="jumpList(item.id)">more</a>
              </h3>
            </div>
            <div class="panel-body">
              <ul class="note-ul">
                <li v-for="(its,index) in item.arts" :key="index">
                  <a href="javascript:;" @click="jumpAtc(its)">
                    <span class="glyphicon glyphicon-star-empty" aria-hidden="true"></span>
                    {{its.name}}
                  </a>
                  <span>{{its.update_time.slice(0,10)}}</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 广告位-->
          <!-- <div class="ad" ><img :src="bgThree"></div> -->
          <div class="ad" v-html="bgThree" ></div>
          <!-- 历年招生 招生信息-->
          <div class="panel panel-primary  overtheyears" v-for="(item,index) in enrollStuPlo" :key="'over'+index">
            <div class="panel-heading">
              <h3 class="panel-title">
                <span class="glyphicon glyphicon-send" aria-hidden="true" ></span> 
                {{item.name}}
                <a class="more" href="javascript:;"  @click="jumpList(item.id)">more</a>
              </h3>
            </div>
            <div class="panel-body">
              <ul class="note-ul">
                <li v-for="(its,index) in item.arts" :key="index">
                  <a href="javascript:;" @click="jumpAtc(its)">
                    <span class="glyphicon glyphicon-star-empty" aria-hidden="true"></span>
                    {{its.name}}
                  </a>
                  <span>{{its.update_time.slice(0,10)}}</span>
                </li>
              </ul>
            </div>
          </div>
          
          
        </div>
        <!-- 右侧内容 -->
        <div class="column-right r">
          <!-- 通知公告-->
          <div class="panel panel-success r-note">
            <div class="panel-heading">
              <h3 class="panel-title">
                <span class="glyphicon glyphicon-bell" aria-hidden="true"></span> 
                {{notice.name}}
                <a class="more" href="javascript:;"  @click="jumpList(notice.id)">more</a>
              </h3>
            </div>
            <div class="panel-body">
              <ul class="note-ul">
                <li v-for="(item,index) in notice.arts" :key="index">
                  <a href="javascript:;" @click="jumpAtc(item)">
                    <span class="glyphicon glyphicon-star-empty" aria-hidden="true"></span>{{item.name}}
                  </a>
                  <span>{{item.update_time.slice(0,10)}}</span>
                </li>
              </ul>
            </div>
          </div>
          <!-- 快速通道-->
          <div class="panel panel-warning fast">
            <div class="panel-heading">
              <h3 class="panel-title">
                <span class="glyphicon glyphicon-plane" aria-hidden="true"></span> 快速通道
              </h3>
            </div>
            <div class="panel-body">
              <router-link :to="'/list/'+tqzs.id"><img src="./img/tqzs.png"></router-link>
              <a :href="Link_url.quertion" target="_blank"><img src="./img/zxwd.png"></a>
              <router-link :to="'/list/'+zsjz.id"><img src="./img/zsjz.png"></router-link>
              <router-link :to="'/list/'+zzzc.id"><img src="./img/zzzc.png"></router-link>
              <router-link :to="'/list/'+gjlx.id"><img src="./img/gjlx.png"></router-link>
              <router-link :to="'/list/'+lxwm.id"><img src="./img/lxwm.png"></router-link>
            </div>
          </div>
          <!-- 热门专业-->
          <div class="panel panel-danger hot">
            <div class="panel-heading">
              <h3 class="panel-title"><span class="glyphicon glyphicon-fire" aria-hidden="true"></span> 
              {{hotPro.name}}
              <a class="more" href="javascript:;" @click="jumpList(hotPro.id)">more</a></h3>
            </div>
            <div class="panel-body"  >
              <a href="#" class="l" v-for="(item,index) in hotPro.arts" :key="index" @click="jumpAtc(item)">{{item.name}}</a>
            </div>
          </div>
        </div>
        <!--轮播图-->
        <carousel-comp></carousel-comp>           
      </div>
    </div>
    <!-- 底部-->
    <foot-comp></foot-comp>  
      <!-- 预加载 -->
    <page-load v-if="loading"></page-load>
    <!-- 提示框 -->
    <tip :tip="tip" v-show="tipShow"></tip>     
  </div>
</template>

<script>
import { getArtCates, getArticles } from "../api/api";
import { Link_url } from "../api/config";
import headComp from "../components/headComp";
import footComp from "../components/footComp";
import carouselComp from "../components/carouselComp";
import pageLoad from "../pageload/pageload";

export default {
  components: { footComp, headComp, carouselComp, pageLoad },
  data() {
    return {
      Link_url: Link_url, //链接
      enrollStu: [], //招生信息
      enrollStuPlo: [], //历年招生
      bgOne: "", //banner背景图1
      bgTwo: "", //banner背景图2
      bgThree: "", //banner背景图3
      notice: {}, //通知公告信息
      hotPro: {}, //热门专业信息
      tqzs: {}, //提前招生信息
      zsjz: {}, //招生简章信息
      zzzc: {}, //资助政策信息
      gjlx: {}, //公交路线信息
      lxwm: {}, //联系我们信息
      tip: {}, //提示语
      loading: true, //预加载
      tipShow: false //提示框默认状态
    };
  },
  created() {
    
  },
  mounted(){
    this._getArtCates(); //获取信息栏目数据
  },
  methods: {
    //获取信息栏目数据
    _getArtCates() {
      // let data = JSON.parse(sessionStorage.getItem("data"));
      this.loading = true;
      // if (data == null) {
        let module = {
          sch_id: 1,
          topic_id: 2
        };
        getArtCates(module)
          .then(res => {
            if (res.status && res.data && res.data.length > 0) {
              // sessionStorage.setItem("data", JSON.stringify(res.data));
              for (let i = 0; i < res.data.length; i++) {
                 if (res.data[i].id ==37||res.data[i].id ==32) {
                  //招生信息 招生章程
                  this.enrollStu.push(res.data[i]);
                   this.enrollStu.reverse()
                  this._getArticles(res.data[i].id, res.data[i]);
                }
                 else if (res.data[i].id == 31 || res.data[i].id == 34) {
                  //考生问答  招生计划
                  this.enrollStuPlo.push(res.data[i]);
                   this.enrollStuPlo.reverse()
                  this._getArticles(res.data[i].id, res.data[i]);
                } 
                 else if (res.data[i].id == 40) {
                  //热门专业
                  this.hotPro = res.data[i];
                  this._getArticles(res.data[i].id, res.data[i]);
                } 
                 else if (res.data[i].id == 39) {
                  //通知公告
                  this.notice = res.data[i];
                  this._getArticles(res.data[i].id, res.data[i]);
                } else if (res.data[i].id == 169) {
                  //提前招生
                  this.tqzs = res.data[i];
                } else if (res.data[i].id == 169) {
                  //招生简章
                  this.zsjz = res.data[i];
                } else if (res.data[i].id == 173) {
                  //资助政策
                  this.zzzc = res.data[i];
                } else if (res.data[i].id == 172) {
                  //公交路线
                  this.gjlx = res.data[i];
                } else if (res.data[i].id == 171) {
                  //联系我们
                  this.lxwm = res.data[i];
                } else if (res.data[i].visible == 2 && res.data[i].odx == 7) {
                  //背景图1
                  this._getArticles(res.data[i].id, res.data[i]);
                } else if (res.data[i].visible == 2 && res.data[i].odx == 8) {
                  //背景图2
                  this._getArticles(res.data[i].id, res.data[i]);
                } else if (res.data[i].visible == 2 && res.data[i].odx == 9) {
                  //背景图3
                  this._getArticles(res.data[i].id, res.data[i]);
                } else if (res.data[i].visible == 2 && res.data[i].odx == 10) {
                  //背景图4
                  this._getArticles(res.data[i].id, res.data[i]);
                }
              }
            } else {
              this.loading = false;
              this.tipCtr("暂无数据");
            }
          })
          .catch(err => {
            this.loading = false;
            this.tipCtr("未找到相关数据,请重新加载");
          });
      // } 
      // else {
      //   for (let i = 0; i < data.length; i++) {
      //     if (data[i].odx <= 4 && data[i].odx >= 3) {
      //       //招生计划  招生章程
      //       this.enrollStu.push(data[i]);
      //       this._getArticles(data[i].id, data[i]);
      //     } else if (data[i].id == 34 || data[i].id == 33) {
      //       //历年招生  招生信息
      //       this.enrollStuPlo.push(data[i]);
      //       this._getArticles(data[i].id, data[i]);
      //     } else if (data[i].id == 39) {
      //       //通知公告
      //       this.notice = data[i];
      //       this._getArticles(data[i].id, data[i]);
      //     } else if (data[i].id == 40) {
      //       //热门专业
      //       this.hotPro = data[i];
      //       this._getArticles(data[i].id, data[i]);
      //     } else if (data[i].id == 169) {
      //       //提前招生
      //       this.tqzs = data[i];
      //     } else if (data[i].id == 169) {
      //       //招生简章
      //       this.zsjz = data[i];
      //     } else if (data[i].id == 173) {
      //       //资助政策
      //       this.zzzc = data[i];
      //     } else if (data[i].id == 172) {
      //       //公交路线
      //       this.gjlx = data[i];
      //     } else if (data[i].id == 171) {
      //       //联系我们
      //       this.lxwm = data[i];
      //     } else if (data[i].visible == 2 && data[i].odx == 7) {
      //       //背景图1
      //       this._getArticles(data[i].id, data[i]);
      //     } else if (data[i].visible == 2 && data[i].odx == 8) {
      //       //背景图2
      //       this._getArticles(data[i].id, data[i]);
      //     } else if (data[i].visible == 2 && data[i].odx == 9) {
      //       //背景图3
      //       this._getArticles(data[i].id, data[i]);
      //     } else if (data[i].visible == 2 && data[i].odx == 10) {
      //       //背景图4
      //       this._getArticles(data[i].id, data[i]);
      //     }
      //   }
      // }
    },

    //获取文章列表
    _getArticles(id, arr) {
      let module = {
        sch_id: 1,
        cate_id: id,
        page: 1,
        pagesize: 7
      };
      getArticles(module)
        .then(res => {
          this.loading = false;
          if (res.status && res.data && res.data.arts.length > 0) {
            if (res.data.visible == 2 && res.data.odx == 7) {
              //背景图1
              let str = res.data.arts[0].des;
              // this.bgOne = str.slice(13, 78);
              this.bgOne = str;
            } else if (res.data.visible == 2 && res.data.odx == 8) {
              //背景图2
              let str = res.data.arts[0].des;
              // this.bgTwo = str.slice(13, 78);
              this.bgTwo = str;
            } else if (res.data.visible == 2 && res.data.odx == 9) {
              //背景图3
              let str = res.data.arts[0].des;
              // this.bgThree = str.slice(13, 78);
              this.bgThree = str;
            } else if (res.data.visible == 2 && res.data.odx == 10) {
              //背景图4
              let str = res.data.arts[0].des;
              // this.bgThree = str.slice(13, 78);
              this.bgThree = str;
            } else if (res.data.id) {
              //通知通告
              this.$set(arr, "arts", res.data.arts);
            } 
            else if (res.data.id < 40 && res.data.id >= 31&&res.data.id != 39&&res.data.id != 33) {
              
              this.$set(arr, "arts", res.data.arts);
             
            } 
            else if (res.data.id == 40) {
              //热门专业
              this.$set(arr, "arts", res.data.arts);
            } 

            // else if (res.data.id == 32 || res.data.id == 31) {
            //   // 招生计划 招生章程
            //   this.$set(arr, "arts", res.data.arts);
            // } else if (res.data.id == 33 || res.data.id == 34) {
            //   //历年招生  招生信息
            //   this.$set(arr, "arts", res.data.arts);
            // }
            
          } else {
            this.tipCtr("暂无数据");
          }
        })
        .catch(err => {
          this.loading = false;
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    //提示框函数
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1200);
    },
    //跳转至列表页面
    jumpList(item) {
      this.$router.push({ path: "/list/" + item });
    },
    //跳转至文章页面
    jumpAtc(list) {
      this.$router.push({ path: "/article/" + list.cate_id + "/" + list.id });
    },
    //跳转到专栏连接
    jumpToClu() {
      window.open(this.Link_url.jump);
    }
  }
};
</script>
<style scoped>
/*banner*/
.banner-box {
  width: 100%;
  height: 250px;
  border-bottom: 1px #eee solid;
}
.banner {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background-size: cover !important;
}
.banner >>> img {
  width: 100%;
  height: 250px;
}
.banner:hover {
  cursor: pointer;
}
/*栏目内容*/
.paddingtop {
  padding: 20px 0;
}
.column-left {
  width: 800px;
}
.column-left > div:nth-child(2n-1) {
  float: left;
}
.column-left > div:nth-child(2n) {
  float: right;
}
.column-left .panel-primary {
  height: 340px;
}
/*招生信息.note*/ /*招生计划.plan*/ /*历年招生.policy*/
.note,
.overtheyears {
  width: 380px;
  margin-left: 20px;
}

.note .panel-heading,
.overtheyears .panel-heading {
  padding: 0 15px;
}

.note h3,
.overtheyears h3 {
  height: 40px;
  line-height: 40px;
}

.note h3 span,
.overtheyears h3 span {
  font-size: 20px;
  top: 4px;
  margin-right: 5px;
}

.more {
  float: right;
}
.more:hover {
  color: #fd1;
}

.panel-body {
  padding: 5px 15px 0;
}

.note-ul li a {
  color: #333;
  font-size: 14px;
  display: inline-block;
  height: 35px;
  line-height: 35px;
  width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.note-ul li:hover a {
  color: red;
}

.note-ul li > span {
  color: #999;
  float: right;
  font-size: 12px;
  line-height: 35px;
}

.note-ul li a > span {
  color: orange;
  font-size: 12px;
  margin-right: 5px;
  top: 1px;
}

.ad {
  width: 800px;
  height: 90px;
  margin-left: 20px;
  margin-bottom: 20px;
  
}
.ad >>>img {
  width: 97.5%;
  height: 90px;
}

/*右边通知公告.r-note*/
.r-note {
  width: 360px;
  margin-right: 20px;
  height: 258px;
  overflow: hidden !important;
}

.r-note .panel-heading {
  padding: 0 15px;
  color: #ffffff;
  background: #5cb85c;
}

.r-note h3 {
  height: 40px;
  line-height: 40px;
}

.r-note h3 span {
  font-size: 20px;
  top: 4px;
  margin-right: 5px;
}

/*快速通道.fast*/
.fast {
  width: 360px;
  margin-right: 20px;
  border-color: #eea236;
}

.fast .panel-heading {
  padding: 0 15px;
  color: #ffffff;
  background: #f0ad4e;
}

.fast h3 {
  height: 40px;
  line-height: 40px;
}

.fast h3 span {
  font-size: 20px;
  top: 4px;
  margin-right: 5px;
}

.fast .panel-body a {
  float: left;
  width: 77px;
  height: 87px;
  margin: 14px 15px;
}

/*热门专业.hot*/
.hot {
  width: 360px;
  height: 229px;
  margin-right: 20px;
  border-color: #d9534f;
  overflow: hidden !important;
}

.hot .panel-heading {
  padding: 0 15px;
  color: #ffffff;
  background: #d9534f;
}

.hot h3 {
  height: 40px;
  line-height: 40px;
}

.hot h3 span {
  font-size: 20px;
  top: 4px;
  margin-right: 5px;
}

.hot .panel-body a {
  padding: 0 5px;
  float: left;
  width: 155px;
  height: 34px;
  text-align: center;
  color: #d9534f;
  background: rgb(255, 217, 217);
  line-height: 34px;
  margin: 5px 0;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hot .panel-body a:hover {
  color: #ffffff;
  background: #d9534f;
}
/* .column-left .panel:nth-child(1),
.column-left .panel:nth-child(2),
.column-left .panel:nth-child(5),
.column-left .panel:nth-child(6) {
  width: 378px;
  height: 338px;
  overflow: hidden;
} */
</style>



// WEBPACK FOOTER //
// src/view/index.vue